<form class="f-col blank-form" [formGroup]="multiTravelerForm">
    <div class="section-heading">
        <h2 class="h2-heading">{{content?.['b2b.managecompany.omfmultitrevelerheading']}} <div class="dot">.</div> <span class="optional">{{content?.['b2b.managecompany.optional']}}</span>
        </h2>
        <a role="button" class="link"
            *ngIf="commonObjPipes.GetAllMultiTravelerDetails.pipe.length>0 && !Addnew"
            (click)="addNewMultiTraveler()"><mat-icon fontSet="material-symbols-outlined" class="edit-icon">add</mat-icon>{{content?.['b2b.managecompany.addnew']}}</a>
    </div>

    <!-- <app-cam-empty-state></app-cam-empty-state> -->

    <div class="section-content" *ngIf="Addnew">

        <div class="inner-contentsection">
            <div class="f-row two--ColLayout">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.omfnooftraveler']}}</mat-label>
                        <input matInput formControlName="numbarOfTraveler" (keypress)="allowedNumberOnly($event)"
                            (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)">

                        <mat-error *ngIf="multiTravelerForm.get('numbarOfTraveler')?.hasError('required')">{{content?.['b2b.managecompany.travelernumberreq']}}</mat-error>
                        <mat-error *ngIf="multiTravelerForm.get('numbarOfTraveler')?.hasError('maxlength')">{{content?.['b2b.managecompany.travelernumbermaxlimit']}}</mat-error>

                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="inner-contentsection">
            <div class="section-heading">
                <h2 class="h2-heading">{{content?.['b2b.managecompany.omftravelerworkflow']}}</h2>
            </div>

            <div class="f-row">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.omfselectproduct']}}</mat-label>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">stat_minus_1</mat-icon>
                        <mat-select formControlName="product">
                            <mat-option *ngFor="let product of commonObjPipes.GetProdectData.pipe" [value]="product.Product_code"> {{product.Product_Name}} </mat-option>
                        </mat-select>
                        <mat-error *ngIf="multiTravelerForm.get('product')?.hasError('required')">{{content?.['b2b.managecompany.selectproductreq']}}</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="f-row">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.ccruleapplied']}}</mat-label>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">stat_minus_1</mat-icon>
                        <mat-select (selectionChange)="onRuleChange($event.value)" formControlName="ruleAppliedOn">
                            <mat-option *ngFor="let rule of commonObjPipes.GetRuleAppliesOn.pipe.slice(1, -1)" [value]="rule.ID"> {{rule.Name}} </mat-option>
                        </mat-select>
                        <mat-error *ngIf="multiTravelerForm.get('ruleAppliedOn')?.hasError('required')">{{content?.['b2b.managecompany.selectrulereq']}}</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="f-row" *ngIf="!!multiTravelerForm.value.ruleAppliedOn">
                <mat-form-field class="mat-chip-input">
                    <mat-label>{{content?.['b2b.managecompany.select']}} {{ getCheckboxLabel() }}</mat-label>
                    <mat-chip-grid #chipGrid aria-label="Fruit selection">
                        <mat-chip-row *ngFor="let name of associatedRuleName" (removed)="remove(name)">
                            {{name}}
                            <button matChipRemove [attr.aria-label]="'remove ' + name">
                                <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
                            </button>
                        </mat-chip-row>
                    </mat-chip-grid>
                    <input placeholder="Select" #fruitInput [formControl]="ruleAppliedFor" [matChipInputFor]="chipGrid"
                        [matAutocomplete]="auto" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        (matChipInputTokenEnd)="add($event)" (keypress)="blockInvalidCharacters1($event)"
                        (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)" />
                    <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">stat_minus_1</mat-icon>
                    <mat-autocomplete #auto="matAutocomplete">
                        <mat-option *ngFor="let filterdAssocNames of filteredAssocatedWithRule | async" [value]="filterdAssocNames">
                            <div (keydown.enter)="$event.stopPropagation()" (keyup.space)="$event.stopPropagation()" (click)="$event.stopPropagation()"> <!-- Add this wrapper div -->
                                <mat-checkbox class="checkbox-wrapper" [checked]="selectedAssoicatedRuleIdMap[filterdAssocNames.ID]" (change)="onCheckboxChange($event, filterdAssocNames)" (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()" (keyup.space)="$event.stopPropagation()"> <!-- Keep this --> {{filterdAssocNames.Name}} </mat-checkbox>
                            </div>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
            <!-- <div class="custom-traveler-row" *ngIf="AssociatedWithBranchArray.length>0 && ![2].includes(multiTravelerForm.value.ruleAppliedOn)">
                <label for="">Select Departments(s):</label>
                <div class="custom-traveler-wrapper">
                    <span *ngFor="let branches of AssociatedWithBranchArray;let i=index">
                        <mat-checkbox (change)="onDepartmentCheckbox($event, branches.ID)"
                            [checked]="EditArrayLists?.associatedWithBranchId?.includes(branches.ID.toString())">{{branches?.Name
                            ?? branches?.name}}</mat-checkbox>
                    </span>
                </div>
            </div> -->

            <div class="f-row"
                *ngIf="AssociatedWithBranchArray.length>0 && ![2].includes(multiTravelerForm.value.ruleAppliedOn)">
                <mat-form-field class="mat-chip-input">
                    <mat-label>{{content?.['b2b.managecompany.select']}} {{ getCheckboxLabel() }}</mat-label>
                    <mat-chip-grid #chipGrid>
                        <mat-chip-row *ngFor="let name of deptDesGradeName" (removed)="removed(name)">
                            {{name}}
                            <button matChipRemove [attr.aria-label]="'remove ' + name">
                                <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
                            </button>
                        </mat-chip-row>
                    </mat-chip-grid>
                    <input placeholder="Select" #fruitInput [formControl]="associatedWithBranchId"
                        [matChipInputFor]="chipGrid" [matAutocomplete]="desDept"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="add($event)"
                        (keypress)="blockInvalidCharacters1($event)" (paste)="onPasteBlocked($event)"
                        (contextmenu)="disableRightClick($event)" />
                    <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">stat_minus_1</mat-icon>

                    <mat-autocomplete #desDept="matAutocomplete">
                        <mat-option *ngFor="let filteredName of filteredDeptDesGrade | async" [value]="filteredName">
                            <div (keydown.enter)="$event.stopPropagation()" (keyup.space)="$event.stopPropagation()" (click)="$event.stopPropagation()"> <!-- Add this wrapper div -->
                                <mat-checkbox class="checkbox-wrapper"
                                    [checked]="this.selectedAssoicatedDeptDesGradeIdMap[filteredName.ID]"
                                    (change)="onDepartmentCheckbox($event, filteredName)"
                                    (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()" (keyup.space)="$event.stopPropagation()"> <!-- Keep this -->
                                    {{filteredName.name || filteredName.Name}}
                                </mat-checkbox>
                            </div>
                           
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>


        </div>

        <div class="inner-action">
            <button mat-button class="button--secondary-small" (click)="onCancel()">{{content?.['b2b.managecompany.cancel']}}</button>
            <button mat-button class="button--primary-small" [class.disabled]="multiTravelerForm.invalid"
                (click)="onSave()">{{content?.['b2b.managecompany.save']}}</button>
        </div>
    </div>

    <div class="section-table data-listing" *ngIf="commonObjPipes.GetAllMultiTravelerDetails.pipe.length>0 && !Addnew">
        <table mat-table [dataSource]="commonObjPipes.GetAllMultiTravelerDetails.pipe" class="mat-elevation-z0">
            <ng-container matColumnDef="Traveler Count">
                <th mat-header-cell *matHeaderCellDef>{{content?.['b2b.managecompany.omftravelercount']}}</th>
                <td mat-cell *matCellDef="let element"> {{element.TravellerCount}} </td>
            </ng-container>
            <ng-container matColumnDef="Applied On">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.appliedon']}} </th>
                <td mat-cell *matCellDef="let element"> {{element.AppliedOnName}} </td>
            </ng-container>

            <ng-container matColumnDef="Product">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.product']}} </th>
                <td mat-cell *matCellDef="let element"> {{element.Product_Name}} </td>
            </ng-container>
            <ng-container matColumnDef="Action">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.ddactions']}} </th>
                <td mat-cell *matCellDef="let element" class="onclick-links">
                    <!-- <a class="onclick-cell primary-link" (click)="onEdit(element)">Edit</a> -->
                    <a tabindex="0" role="button" aria-label="Edit item" class="onclick-cell primary-link" (keydown.enter)="onEdit(element)" (click)="onEdit(element)"><mat-icon fontSet="material-symbols-outlined">edit</mat-icon></a>
                    <!-- <a class="onclick-cell warm-link" (click)="onRemove(element)">Remove</a> -->
                    <a tabindex="0" role="button" aria-label="remove item" class="onclick-cell warm-link" (keydown.enter)="onRemove(element)" (click)="onRemove(element)"><mat-icon fontSet="material-symbols-outlined">delete</mat-icon></a>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
    <ng-container *ngIf="!isLoading && commonObjPipes.GetAllMultiTravelerDetails.pipe.length==0 && !Addnew">
        <app-cam-empty-state (myEvent)="handleEvent($event)" [heading]="'No multi traveler rules configured'"
            [content]="'And multi traveler details to streamline policy and approval workflows.'"
            [navigateTo]="'/cam/company-management/multi-travel-management'">
        </app-cam-empty-state>
    </ng-container>


</form>

<ng-template #selectionWarning>
    <div class="custom-dialog">
        <div class="d-justify-bw">
            <div class="custom-dialog__left">
                <div class="mat-dialog-title custom-dialog__title d-justify-bw">
                    <h2 class="mat-dialog-title"> {{ ancillariesSitecoreContent?.['b2b.ancillaries.global.confirmcta'] }} changes</h2>
                    <!-- <div class="custom-overlay-close">
                        <mat-icon fontSet="material-symbols-outlined" class="close_icon" (click)="CloseDialog(false)">close</mat-icon>
                    </div> -->
                </div>
                <mat-dialog-content class="custom-dialog__text">
                    <div class="custom-dialog__description">Are you sure you want to remove this multi traveler management?</div>
                </mat-dialog-content>
                <mat-dialog-actions>
                    <div class="dialog-actions-right">
                        <button class="button--secondary-small" mat-button (click)="CloseDialog(false)">Cancel</button>
                        <button class="button--primary-small" mat-button (click)="CloseDialog(true)">{{ ancillariesSitecoreContent?.['b2b.ancillaries.global.confirmcta'] || 'Confirm' }}</button>
                    </div>
                </mat-dialog-actions>
            </div>
        </div>
    </div>
</ng-template>